import styled from '@emotion/styled';
import { MainTableBodyCell, MainTableBodyRow, MainTableHeaderCell, MainTableHeaderRow, MainTableLink, MainTableWrapper } from 'src/components/Table/Table.style';

export const TableWrapper = styled(MainTableWrapper, { label: 'TableWrapper' })``;

export const TableHeaderRow = styled(MainTableHeaderRow, { label: 'TableHeaderRow' })``;
export const TableHeaderCell = styled(MainTableHeaderCell, { label: 'TableHeaderCell' })``;

export const TableBodyRow = styled(MainTableBodyRow, { label: 'TableBodyRow' })``;
export const TableBodyCell = styled(MainTableBodyCell, { label: 'TableBodyCell' })``;

export const TableLink = styled(MainTableLink, { label: 'TableLink' })``;

export const ButtonsWrapper = styled('div', { label: 'ButtonsWrapper' })`
    display: flex;
    grid-gap: 8px;
    align-items: center;
    button:not(:first-of-type) {
        margin-top: 0;
    }
`;
